import { nativeLoginOpts } from "@/native/auth";
import { useAuth0 } from "@auth0/auth0-react";
import { Spinner } from "@cohesive/ui-components";
import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export function useLoginRedirect() {
  const { loginWithRedirect } = useAuth0();

  const [searchParams] = useSearchParams();
  const organization = useMemo(
    () => searchParams.get("organization"),
    [searchParams],
  );
  const invitation = useMemo(
    () => searchParams.get("invitation"),
    [searchParams],
  );

  if (organization && invitation) {
    loginWithRedirect({
      authorizationParams: {
        organization,
        invitation,
      },
      ...nativeLoginOpts(),
    });

    return null;
  }

  return null;
}

const LoginPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-dvh">
      <Spinner size="xl" />
    </div>
  );
};

export default LoginPage;
